<template>
    <div class="tc-outline-button"
         @click.stop="$emit('click')">
        {{text}}
    </div>
</template>

<script>
export default {
    name: 'OutlineButton',
    props: [
        'text',
    ],
    emits: [
        'click',
    ],
};
</script>

<style scoped lang="scss">
.tc-outline-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    color: #00458D;
    border: 1px solid currentColor;
    transition: 0.3s ease all;
    background-color: white;
}

.tc-outline-button:hover {
    color: #ffffff;
    background-color: #00458D;
    //background-color: #0170E3;
}

.tc-outline-button:active {
    background-color: #003771;
}

</style>
